
import { Fragment, useRef, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
// import { ExclamationIcon } from '@heroicons/react/outline'
import { AiOutlineMinus, AiOutlinePlus, AiOutlineStar, AiFillStar } from 'react-icons/ai'
import { IoMdCloseCircle } from 'react-icons/io'
import product from '../.../../../../Assert/products/product.jpg'
import { NavLink } from 'react-router-dom'
import Card from './Card'
import { useSelector } from 'react-redux'

export default function CardModal({ setModal, modal }) {
    const [quantity, setQuantity] = useState(0)
    const [switchBtn, setSwitchBtn] = useState("details")


    const cancelButtonRef = useRef(null)

    const productList = useSelector((state) => state.cart.allProducts)

    return (
        <Transition.Root show={modal} as={Fragment}>
            <Dialog as="div" className="fixed z-10 inset-0 overflow-y-auto" initialFocus={cancelButtonRef} onClose={setModal}>
                <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0 relative">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                        &#8203;
                    </span>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle lg:max-w-4xl md:max-w-2xl sm:max-w-xl sm:w-full">
                            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                <div className="sm:flex sm:items-start">
                                    <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                        {/* <ExclamationIcon className="h-6 w-6 text-red-600" aria-hidden="true" /> */}
                                    </div>
                                    <div className="grid grid-cols-2">
                                        <div className="">
                                            <img src={product} alt="" />
                                        </div>
                                        <div className="flex flex-col space-y-2">
                                            <h3 className='text-black font-semibold text-xl leading-5'>Blueberries</h3>
                                            <p>1lb</p>
                                            <p>Blueberries are perennial flowering plants with blue or purple berries. They are classified in the section Cyanococcus within the genus Vaccinium. Vac...</p>
                                            <NavLink to="#" className={"text-blue-600"}>See more</NavLink>
                                            <h1 className='text-3xl font-bold text-teal-700'>$3.00</h1>
                                            <div className="flex justify-between flex-col lg:flex-row gap-2">
                                                {quantity ? <div className="bg-gradient-to-t hover:from-red-800 hover:to-red-400 from-red-600 to-red-300 px-2 py-1 rounded-md shadow-sm flex justify-between text-white w-40 items-center ">
                                                    <AiOutlineMinus onClick={() => quantity && setQuantity(quantity - 1)} className='text-2xl cursor-pointer' />
                                                    <span className='text-xl'>{quantity}</span>
                                                    <AiOutlinePlus onClick={() => setQuantity(quantity + 1)} className='text-2xl cursor-pointer ' />
                                                </div> : 
                                                <div onClick={() => setQuantity(quantity + 1)} className="bg-gradient-to-t hover:from-red-800 hover:to-red-400 from-red-600 to-red-300 px-2 py-1 rounded-md shadow-sm flex justify-between text-white w-40 items-center cursor-pointer ">
                                                <p className='text-center w-full text-md tracking-wider'>Add to cart</p>
                                            </div>
                                            }
                                                <p className='text-lg text-black  '>{30 - quantity} pieces available</p>
                                            </div>
                                            <div className="flex gap-x-2 py-2">
                                                <h3 className='text-lg font-semibold'>Categories:</h3>
                                                <p className='shadow-lg hover:border hover:border-red-300 rounded-md  px-2 cursor-pointer'>fruits & vegetables</p>
                                                <p className='shadow-lg hover:border hover:border-red-300 rounded-md  px-2 cursor-pointer'>fruits</p>

                                            </div>



                                        </div>
                                    </div>

                                </div>
                                <div className='w-full '>
                                    <div className="flex my-2 ">
                                        <h3 className={`${switchBtn === "details" && "border-b-0"} text-black text-xl font-semibold border-2 border-red-300  px-2 py-1   rounded-tl-md cursor-pointer`} onClick={() => setSwitchBtn("details")}>Details </h3>

                                        <h3 className={`${switchBtn === "review" && "border-b-0"} text-black text-xl font-semibold border-2 border-red-300  px-2 py-1 rounded-tr-md border-l-0 cursor-pointer`} onClick={() => setSwitchBtn("review")}>Review  </h3>
                                    </div>
                                    {switchBtn === "details" && <p className='text-gray-700'>Blueberries are perennial flowering plants with blue or purple berries. They are classified in the section Cyanococcus within the genus Vaccinium. Vaccinium also includes cranberries, bilberries, huckleberries and Madeira blueberries. Commercial blueberries—both wild and cultivated —are all native to North America.</p>}
                                    {switchBtn === "review" && <>

                                        {
                                            Array.from({ length: 3 }).map((_, id) => <div key={id} className='flex gap-x-2 my-3 items-center'>
                                                <div className="">
                                                    <img
                                                        className=" w-16 rounded-full"
                                                        src="https://images.unsplash.com/photo-1491528323818-fdd1faba62cc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="flex flex-col gap-y-2">
                                                    <div className="flex gap-x-2 items-center">
                                                        <h3>AZAD</h3>
                                                        <div className="flex gap-x-1 text-orange-400">
                                                            <AiFillStar />
                                                            <AiFillStar />
                                                            <AiFillStar />
                                                            <AiFillStar />
                                                            <AiOutlineStar />
                                                        </div>
                                                    </div>
                                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis nemo eum quos vero totam labore impedit alias ad quasi nesciunt?</p>
                                                </div>
                                            </div>)
                                        }
                                    
                                    </>
                                    }
                                </div>
                                <div className="my-4">
                                    <h3 className='text-black text-xl font-semibold my-2'>Related Products </h3>
                                    <div className="grid md:grid-cols-4 grid-cols-2 gap-4">
                                        {
                                            productList.map((product) => {
                                                return (
                                                    <Card key={product._id} {...product} />
                                                )
                                            })
                                        }
                                    </div>

                                </div>
                            </div>

                            <IoMdCloseCircle onClick={() => setModal(false)} className='fixed -top-0 overflow-hidden -right-0 cursor-pointer hover:scale-110 transition-transform duration-700 font-bold text-3xl text-red-500' /></div>

                    </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>
    )
}
